<template>
  <div>
    <router-view ref="view"/>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/frame/showCompany/showCompany.vue